import axios from "axios";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 5000
});

const errorInterceptor = error => {
  if (!error.response) {
    //Vue.notify({ type: "error", text: "Network/Server error" });
    return Promise.reject(error);
  }

  switch (error.response.status) {
    case 400:
      //console.error(error.response.status, error.message);
      //Vue.notify({ type: "error", text: "Invalid Request" });
      break;

    default:
    //console.error(error.response.status, error.message);
    //Vue.notify({ type: "error", text: "Server Error" });
  }
  return Promise.reject(error);
};

const responseInterceptor = response => {
  switch (response.status) {
    case 200:
      break;
    default:
  }

  return response;
};

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
